// extracted by mini-css-extract-plugin
export default {"container":"SJ-z","topReviewHeading":"TJ-z","criticalReview":"UJ-z","favorableReview":"VJ-z","vsSeparator":"WJ-z"};